function hulk_custom_init() {

    function getPriceFromText(text) {
        return parseInt((text || '').replace(/\D/g, '')) || 0;
    }

    function attachPercentages() {
        document.querySelectorAll('.custom-select').forEach((option) => {
            const percentages = option.querySelector('.hulkapps_helptext')?.textContent.split('|').map(el => el.trim()) || [];
            if (option.classList[1] == 'swatch_render') {
                option.querySelectorAll('.hulkapps_option_child').forEach((child, i) => {
                    if (percentages[i]) {
                        child.setAttribute('data-percentage-charge', percentages[i]);
                    }
                });
            } else if (option.classList[1] == 'dd_render') {
                option.querySelectorAll('select option').forEach((child, i) => {
                    if (percentages[i]) {
                        child.setAttribute('data-percentage-charge', percentages[i]);
                    }
                })
            }
        });
    }

    function calculateTotalPrice() {
        const productPrice = getPriceFromText(document.querySelector('[data-product-price]')?.textContent);
        const addonCharge = getPriceFromText(document.querySelector('.hulk_price_addtional_charge_beside_price')?.textContent);

        const hasFormulaPrice = Array.from(document.querySelectorAll('.custom-charge'))
            .some(el => el.querySelector('.hulk_formula_hidden_prop')?.getAttribute('data-price') !== '');

        if (hasFormulaPrice) {
            const formulaCharges = Array.from(document.querySelectorAll('.custom-charge')).map((option) => {
                const dataPrice = option.querySelector('.hulk_formula_hidden_prop')?.getAttribute('data-price') || '';
                return getPriceFromText(dataPrice);
            });

            const totalFormulaCharge = formulaCharges.reduce((acc, val) => acc + val, 0);
            return productPrice + (addonCharge - totalFormulaCharge);
        }
        return productPrice + addonCharge;
    }

    function passCustomPrices() {
        const totalPrice = calculateTotalPrice();

        document.querySelectorAll('.custom-select').forEach((select) => {

            // Logic for swatch option

            if (select.classList[1] == 'swatch_render') {
                const selectedSwatch = select.querySelector('.hulkapps_option_child.swatch_selected');
                if (!selectedSwatch) return;

                const percentage = parseInt(selectedSwatch.getAttribute('data-percentage-charge')) || 0;
                const relativeClass = Array.from(select.classList).at(-2);
                const formulaElement = document.querySelector(`.fm_render.custom-charge.${relativeClass}`);

                if (formulaElement) {
                    console.log('Found formula element: ', formulaElement);
                    const formulaInput = formulaElement.querySelector('.hulk-form-field:nth-child(2) input');
                    formulaInput.setAttribute('step', 'any')
                    if (formulaInput && percentage > 0) {
                        const result = (totalPrice * (percentage / 100)) / 100;
                        formulaInput.value = result;
                        console.log(result);
                        formulaInput.dispatchEvent(new Event('change',{bubbles: true, detail: {isProgrammatic: true}}));
                    }
                }
            } else if (select.classList[1] == 'dd_render') {
                const selectedOption = select.querySelector('option:checked');
                if (!selectedOption) return;

                const percentage = parseInt(selectedOption.getAttribute('data-percentage-charge')) || 0;
                const relativeClass = Array.from(select.classList).at(-2);
                const formulaElement = document.querySelector(`.fm_render.custom-charge.${relativeClass}`);
                if (formulaElement & percentage > 0) {
                    const formulaInput = formulaElement.querySelector('.hulk-form-field:nth-child(2) input');
                    formulaInput.setAttribute('step', 'any');
                    if (formulaInput) {
                        const result = (totalPrice * (percentage / 100)) / 100;
                        formulaInput.value = result;
                        formulaInput.dispatchEvent(new Event('change',{bubbles: true, detail: {isProgrammatic: true}}));
                    }
                }
            }
        });
    }

    document.addEventListener('click', (e) => {
        if (e.target.classList.contains('hulkapps_option_child')) {
            console.log('Click on: ', e.target);
            setTimeout(() => {
                passCustomPrices();
            }, 300);
        }
    });

    document.addEventListener('change', (e) => {
        if (e.target.classList.contains('hulkapps_option_child') && e.detail?.isProgrammatic === true) {
            console.log('Change on: ', e.target);
            setTimeout(() => {
                passCustomPrices();
            }, 300);
        }
    });

    // === Initial setup ===
    attachPercentages();
    console.log('HulkApps - Custom Percentage - Loaded');
}

window.addEventListener('load', () => {
    const hook = setInterval(() => {
        const hulk_div = document.querySelector('[id^="hulkapps_custom_options"]');
        if (hulk_div && hulk_div.querySelector('.custom-charge')) {
            clearInterval(hook);
            hulk_custom_init();
        }
    }, 50)

    setTimeout(() => {
        clearInterval(hook);
    }, 10000);
})